import { render, staticRenderFns } from "./App.vue?vue&type=template&id=19c7fd98&scoped=true"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=19c7fd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7fd98",
  null
  
)

export default component.exports